import { heroData } from '@/mocks/home';

export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20atmosphere%20with%20warm%20golden%20and%20amber%20spotlights%20illuminating%20dramatic%20movie%20projection%2C%20elegant%20velvet%20curtains%20with%20rich%20texture%2C%20soft%20smoke%20haze%20effect%2C%20luxurious%20deep%20warm%20color%20palette%2C%20no%20text%2C%20abstract%20cinematic%20composition%2C%20high%20end%20photography&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="天堂影院观影氛围"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/80"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-sm font-medium mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-50 leading-tight mb-4">
              天堂影院 · 高清不缓冲<br className="hidden sm:block" /> 流畅在线观影平台
            </h1>
            <p className="text-base md:text-lg text-accent-400 font-medium mb-6">
              {heroData.slogan}
            </p>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8 max-w-[620px] lg:max-w-none">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(heroData.primaryCta.href); }}
                className="w-full sm:w-auto px-8 py-3 bg-accent-500 text-background-50 font-semibold rounded-lg hover:bg-accent-600 transition-all duration-200 text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>
                {heroData.primaryCta.text}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(heroData.secondaryCta.href); }}
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300/40 text-foreground-200 font-medium rounded-lg hover:border-accent-500 hover:text-accent-400 transition-all duration-200 text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line mr-2"></i>
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-background-950/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20featuring%20dramatic%20film%20scenes%20blended%20artistically%2C%20warm%20golden%20and%20amber%20toned%20color%20grading%2C%20dark%20rich%20shadows%2C%20professional%20cinematic%20composition%2C%20elegant%20movie%20poster%20style%2C%20no%20visible%20text%2C%20artistic%20photography&width=800&height=560&seq=hero-visual-01&orientation=landscape"
                alt="天堂影院精选影片视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex items-center gap-1.5 bg-background-950/70 backdrop-blur-sm rounded-full px-4 py-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
                  <span className="text-xs text-foreground-200 whitespace-nowrap">蓝光画质</span>
                </div>
                <div className="flex items-center gap-1.5 bg-background-950/70 backdrop-blur-sm rounded-full px-4 py-2">
                  <i className="ri-flashlight-line text-accent-400 text-xs"></i>
                  <span className="text-xs text-foreground-200 whitespace-nowrap">极速播放</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}